import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './../node_modules/bulma/css/bulma.css';

import Default from "./layouts/Default.vue";
import DigitalPrint from "./layouts/DigitalPrint.vue";
import Leisurewear from "./layouts/Leisurewear.vue";
import Sales from "./layouts/Sales.vue";
import Production from "./layouts/Production.vue";
import Strabane from "./layouts/Strabane.vue";
import Reports from "./layouts/Reports.vue";
import Home from "./layouts/Home.vue";
import Input from "./layouts/Input.vue";
import Blank from "./layouts/Blank.vue";
import PrintingCutting from "./layouts/PrintingCutting.vue";
import OffshorePrintingCutting from "./layouts/OffshorePrintingCutting.vue";
import Makeup from "./layouts/Makeup.vue";
import Finance from "./layouts/Finance.vue";
import Orders from "./layouts/Orders.vue";
import CutSew from "./layouts/CutSew.vue";
import Offshore from "./layouts/Offshore.vue";
import Samples from "./layouts/Samples.vue";
import Knit from "./layouts/Knit.vue";

Vue.component('default-layout', Default);
Vue.component('digitalprint-layout', DigitalPrint);
Vue.component('leisurewear-layout', Leisurewear);
Vue.component('sales-layout', Sales);
Vue.component('production-layout', Production);
Vue.component('strabane-layout', Strabane);
Vue.component('reports-layout', Reports);
Vue.component('home-layout', Home);
Vue.component('input-layout', Input);
Vue.component('blank-layout', Blank);
Vue.component('printingcutting-layout', PrintingCutting);
Vue.component('offshoreprintingcutting-layout', OffshorePrintingCutting);
Vue.component('makeup-layout', Makeup);
Vue.component('finance-layout', Finance);
Vue.component('orders-layout', Orders);
Vue.component('cutsew-layout', CutSew);
Vue.component('offshore-layout', Offshore);
Vue.component('samples-layout', Samples);
Vue.component('knit-layout', Knit);

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "./auth";

// Global functions
Vue.mixin({
  methods: {
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
  },
})

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false

// Filter to format a MySQL date into the UK format for display
Vue.filter('formatUKDate', function (value) {
  if (!value) return '';

  const date = new Date(value);

  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();

  const hours = ('0' + date.getHours()).slice(-2);
  const mins = ('0' + date.getMinutes()).slice(-2);

  return `${day}/${month}/${year} ${hours}:${mins}`;
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')